import { call, put, takeEvery, select } from 'redux-saga/effects';
import { startLoading, stopLoading } from '@redux/actions';

import { createFlashMessage } from '../../components/Flash/redux';
import { FlashMessages } from '../../components/Flash/redux/flash-messages';
import {
  getIsUserDeletedAccount,
  postDeleteAccount,
  postRevertDeleteAccount
} from '../../utils/ajax';
import { deleteAccountError } from './actions';
import { actionTypes } from './action-types';

function* deleteAccountSaga() {
  try {
    yield put(startLoading('deleteAccount'));
    yield call(postDeleteAccount);
    yield put(
      createFlashMessage({
        type: 'info',
        message: FlashMessages.AccountDeleted,
        variables: { dismissible: true }
      })
    );
    yield call(isUserRequestedToDeleteAccountSaga);
  } catch (e) {
    yield put(deleteAccountError(e));
  } finally {
    yield put(stopLoading('deleteAccount'));
  }
}

function selectUser(state) {
  return state?.app?.user?.[state?.app?.appUsername];
}

export function* isUserRequestedToDeleteAccountSaga() {
  try {
    const user = yield select(selectUser);

    if (!user?.id) return;

    const { data } = yield call(getIsUserDeletedAccount);
    yield put({
      type: actionTypes.isUserRequestedToDeleteAccountComplete,
      payload: data
    });
  } catch (error) {
    yield put(
      createFlashMessage({
        type: 'error',
        message: 'Erro ao verfíficar se conta foi solicitada a exclusão!',
        variables: { dismissible: true }
      })
    );
  }
}

function* revertDeleteAccountSaga() {
  try {
    yield put(startLoading('deleteAccount'));
    const { data } = yield call(postRevertDeleteAccount);

    yield put({
      type: actionTypes.revertDeleteAccountComplete,
      payload: data
    });

    yield call(isUserRequestedToDeleteAccountSaga);
  } catch (error) {
    yield put(
      createFlashMessage({
        type: 'error',
        message: 'Erro ao reverter exclusão da conta!',
        variables: { dismissible: true }
      })
    );
  } finally {
    yield put(stopLoading('deleteAccount'));
  }
}

export function createDangerZoneSaga(types) {
  return [
    takeEvery(types.deleteAccount, deleteAccountSaga),
    takeEvery(types.revertDeleteAccount, revertDeleteAccountSaga)
  ];
}
